import React from 'react';

import { Box } from '@mui/material';

import { CommunityProfile } from 'pages/CommunityProfile';
import FormListPage from 'pages/FormListPage';
import Rooms from 'pages/Rooms';
import { MenuItem, isFormExtras, isMeetingRoomExtras } from 'types/menuTypes';

interface RenderMenuContentProps {
  menu?: MenuItem | null;
  children?: React.ReactNode;
}

const RenderMenuContent: React.FC<RenderMenuContentProps> = ({ menu, children }) => {
  console.log('[RenderMenuContent] Renderizando:', {
    menuLabel: menu?.label,
    menuPath: menu?.path,
    dynamicComponent: menu?.feature?.dynamic_component,
    documentId: menu?.feature?.documentId,
    hasExtras: !!menu?.feature?.extras,
  });

  if (!menu) return <>{children}</>;

  const dynamicComponent = menu.feature?.dynamic_component;
  const extras = menu.feature?.extras || null;

  console.log('[RenderMenuContent] Processando dynamic_component:', dynamicComponent);

  switch (dynamicComponent) {
    case 'FORM':
      console.log('[RenderMenuContent] Renderizando FORM');
      if (isFormExtras(extras)) {
        return (
          <FormListPage
            formGroupId={extras.form_group_id}
            formGroupName={extras.form_group_name}
            menu={menu}
          />
        );
      }
      return <FormListPage menu={menu} />;

    case 'FORM_DASHBOARD':
      console.log('[RenderMenuContent] Renderizando FORM_DASHBOARD');
      if (isFormExtras(extras)) {
        return <CommunityProfile formId={extras.form_id} formName={extras.form_name} menu={menu} />;
      }
      return <CommunityProfile menu={menu} />;

    case 'MEETING_ROOM':
    case 'MEETING_ROOM_ROOM':
      if (isMeetingRoomExtras(extras)) {
        return (
          <Rooms
            roomId={extras.internal_id}
            roomName={menu.label}
            vendorCode={extras.vendor_code}
            roomKey={extras.key}
            background={extras.background}
            menu={menu}
          />
        );
      }
      return <Rooms menu={menu} />;

    default:
      console.log('[RenderMenuContent] Renderizando children padrão');
      return <Box width="100%">{children}</Box>;
  }
};

export default RenderMenuContent;
